import AllInboxIcon from '@mui/icons-material/AllInbox';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Groups2Icon from '@mui/icons-material/Groups2';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import RuleIcon from '@mui/icons-material/Rule';
import { Box, useTheme } from '@mui/material';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { useSupervisorQueueHeader } from './useSupervisorQueueHeader';
import { HeaderStatsItem } from '../../workspace-common/components/HeaderStatItem';

const HeaderStatsSection = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { supervisorTaskCountData, isSupervisorAllocationSummaryLoading } =
    useSupervisorQueueHeader();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(6) }}>
      <HeaderStatsItem
        label={formatMessage({ id: 'supervisorQueue.header.stats.total.title' })}
        value={supervisorTaskCountData?.total ?? null}
        isLoading={isSupervisorAllocationSummaryLoading}
        icon={<AllInboxIcon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'supervisorQueue.header.stats.pendingByBoth.title' })}
        value={supervisorTaskCountData?.pendingByBoth ?? null}
        isLoading={isSupervisorAllocationSummaryLoading}
        icon={<Groups2Icon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'supervisorQueue.header.stats.completed.title' })}
        value={supervisorTaskCountData?.completed ?? null}
        isLoading={isSupervisorAllocationSummaryLoading}
        icon={<DoneAllIcon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'supervisorQueue.header.stats.finalizedByOne.title' })}
        value={supervisorTaskCountData?.finalizedByOne ?? null}
        isLoading={isSupervisorAllocationSummaryLoading}
        icon={<PersonOutlineIcon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'supervisorQueue.header.stats.finalizedByBoth.title' })}
        value={supervisorTaskCountData?.conflictsPending ?? null}
        isLoading={isSupervisorAllocationSummaryLoading}
        icon={<RuleIcon sx={{ width: 16, height: 16 }} />}
      />
      <HeaderStatsItem
        label={formatMessage({ id: 'supervisorQueue.header.stats.draft.title' })}
        value={supervisorTaskCountData?.draftCount ?? null}
        isLoading={isSupervisorAllocationSummaryLoading}
        icon={<EditNoteIcon sx={{ width: 16, height: 16 }} />}
      />
    </Box>
  );
};

export const SupervisorQueueHeader = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  return (
    <Box
      sx={{
        pt: theme.spacing(4),
      }}
    >
      <Box>
        <Typography variant="h4">
          {formatMessage({ id: 'supervisorQueue.header.title' })}
        </Typography>
      </Box>

      {/* Header stats section */}
      <HeaderStatsSection />
    </Box>
  );
};
